<template>
  <transition
    name="zoom-fade"
    :key="$route.name"
    mode="out-in"
    @before-leave="overflow('hidden')"
    @after-leave="overflow('auto')"
    @before-enter="overflow('hidden')"
    @after-enter="overflow('auto')"
  >
    <router-view></router-view>
  </transition>
</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['getRole']),
  },
  beforeMount() {
    this.$router.beforeResolve((to, from, next) => {
      let redirect = this.checkAccess(to);
      if (redirect) return next(redirect);
      next();
    });
  },
  methods: {
    checkAccess(route) {
      if (!route.name) return null;
      if (!route.name.includes('.cabinet')) return null;
      if (!route.name.includes(`${this.getRole}.`)) return {name: 'home', params: {permission: true}};
      return null;
    },
    overflow(v) {
      document.body.style.overflow = v
    },
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
@import "./assets/transitions.css";

.pointer {
  cursor: pointer;
}

.no-select {
  -moz-user-select: none;
  -khtml-user-select: none;
  user-select: none;
}

* {
  outline: none;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.overflow_hidden {
  overflow: hidden !important;
}

body {
  font-family: "Open Sans", sans-serif;
}

h3 {
  font-family: "Montserrat", sans-serif;
}

@font-face {
  font-family: "Montserrat";
  src: url("./assets/fonts/Montserrat-SemiBold.woff") format("woff"),
  url("./assets/fonts/Montserrat-SemiBold.woff2") format("woff2");
  font-weight: 600;
}

@font-face {
  font-family: "Montserrat";
  src: url("./assets/fonts/Montserrat-Regular.woff") format("woff"),
  url("./assets/fonts/Montserrat-Regular.woff2") format("woff2");
  font-weight: normal;
}

button, a {
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}

$green: #97C1BF;

.calendar_popup {
  z-index: 2;
  width: 365px;
  position: absolute;
  top: 200px;
  background-color: #FAFAFA;
  border: 2px solid $green;
  border-radius: 5px;
  padding-left: 20px;
  padding-right: 50px;
  padding-top: 20px;

  &.left_arrow:after {
    right: -17px;
    background-image: url('./assets/images/icons/modal_cheveron_right.svg');
    background-position: center center;
    background-size: contain;
  }

  &.right_arrow:after {
    left: -17px;
    transform: rotateY(180deg);
    background-image: url('./assets/images/icons/modal_cheveron_right.svg');
    background-position: center center;
    background-size: contain;
  }

  &:after {
    content: '';
    display: block;
    width: 20px;
    height: 20px;
    position: absolute;
    z-index: 99;
    top: 50%;
    transform: translateY(-50%);
    background-position: center center;
    background-repeat: no-repeat;
  }

  .close {
    position: absolute;
    right: 10px;
    top: 10px;
    border: none;
    background-color: transparent;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
    }
  }

  input, select {
    display: block;
    background-color: #FFFFFF;
    border: 1px solid #97C1BF;
    border-radius: 5px;
    margin-bottom: 10px;

    padding-left: 15px;
    width: 100%;
    height: 40px;

    font-family: "Open Sans", sans-serif;
    font-size: 16px;

    &::placeholder {
      color: #808080;
    }

    &:disabled {
      opacity: .8;
    }
  }

  .desc_text {
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    line-height: 1.71;
    color: #808080;
    margin-bottom: 10px;
  }

  .save_btn {
    width: calc(100% + 70px);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 48px;

    border: none;
    border-top: 2px solid #97C1BF;
    background-color: #fff;

    margin-left: -20px;
    margin-right: -50px;

    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    line-height: 1.5;
    color: #383838;

    &.isEdit {
      width: 100%;
      margin: 0 auto;
    }
  }

  .timepicker_wrap {
    display: flex;
    align-items: center;

    input {
      width: 80px;
      appearance: none;

      &::-webkit-calendar-picker-indicator {
        display: none;
      }
    }

    span {
      line-height: 1;
      margin: 0 5px;
      transform: translateY(-5px);
    }
  }

  .buttons_group {
    display: flex;
    width: calc(100% + 70px);
    margin-left: -20px;
    margin-right: -50px;

    button {
      width: 50%;
      margin-left: 0;
      margin-right: 0;

      &:first-child {
        border-right: 2px solid #97C1BF;
      }
    }
  }
}

.Vue-Toastification__toast--success {
  background-color: #97c1bf !important;
}

.Vue-Toastification__toast--error {
  background-color: #b9765b !important;
}
</style>
